module.exports = __webpack_public_path__ + "static/img/useInstru.0056d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/useInstru.png
// module id = B6At
// module chunks = 55